import * as React from 'react';
import {NotionWrapper} from '@ux/notion-api';

const NotionVoiceAndToneEasy = () => (
	<NotionWrapper blockMap={{
	"blocks": [
		{
			"id": "e916c9a3-5983-4c34-bec3-187e417c593c",
			"type": "page",
			"properties": {
				"title": [
					[
						"Пишем просто"
					]
				]
			},
			"content": [
				"cc4617c1-0f91-4b55-b2c0-45951974a57c",
				"5ec53dbc-b92e-44ef-94c1-48cdc837607e",
				"928f3ae0-7d34-4447-9d27-8d672ca1d4e1",
				"7bf75ea7-a3cf-47a1-9c4a-ecb412e77b84",
				"17b36a19-a996-4632-8fdd-1278997bbdc1",
				"fb7f94c5-9a95-4ec0-b7c2-00ecf0819328",
				"916ffdab-ca2f-4964-b0ba-968ab34de1d9",
				"93d06b98-b4c8-4100-83eb-d6ac3df8dc07",
				"487c9f61-b59d-4ad3-9521-ab032644efbb",
				"f52a03f6-3fc8-453f-b867-55103b76c639",
				"ea881711-5a72-45a7-a7d2-c8efdd5d87cf",
				"aaf0a349-1403-4b93-a79a-cfa1e3a4bd9e",
				"72745913-9f75-4f67-a382-e64f7cbd0efd",
				"fff625a0-c310-4551-a188-a6f6ad25ac0e",
				"f76d8a69-ea9e-4996-b288-a1059f8f90d4",
				"c2ab34e8-76b4-4eeb-a457-03090a9cc536",
				"dd89bf51-c88b-4212-9813-2f94e08d2584",
				"816a2b0b-130e-43bc-90b5-1eba8ea1d440",
				"361bcc88-23d5-466a-87cb-5cf935a9df44",
				"6c3b19de-c6c9-40d5-8052-ab09f496599f",
				"dfd68174-a8f8-4104-9471-706d68ee593a",
				"326899f1-f77b-4fef-97da-76f12df4a964",
				"48b790b0-832d-47d0-95b6-6927439de720",
				"b81cd1f6-479d-4376-a67d-7ab3784587c3",
				"b3b6e0da-d07d-40f5-ba86-8062752eef4d",
				"1f57704d-6a51-4588-a2fe-773c735386bf",
				"9b4229c0-0d72-460d-87d0-e1c6cd975286",
				"39c7c837-f926-4824-8ff0-fbab227c235b",
				"fa017015-8311-4496-8a0d-913d868570d0",
				"cfd23cf5-5533-4149-b6f1-2c6ea86ae040",
				"b59f1e21-862e-47c0-90db-c7def32d7112",
				"e91be86a-90df-437e-a48e-744dc3dc7a8d",
				"bcb6d40e-5a48-4f23-9d99-a4fab9669180",
				"502ec16b-cd79-4108-9f8c-2588337fe612",
				"5eae1602-464e-49a2-a50f-8488eeb3f3a3",
				"218e76a5-3577-4267-be42-aad8b069b42b",
				"5cf3aa65-e1e3-4a70-a8cb-ad4414bf425a",
				"744867c2-afd1-46cb-83bb-132b4a7db315",
				"37b066a8-29c2-478c-8eb5-102eb7384bed",
				"290b78a6-8309-41fe-9ab9-f1d3c6e16662",
				"7c3e71db-3010-4f1f-ab6f-499f7923ec3a",
				"bc39034e-2c64-44bc-a3db-f38ab00c27fd"
			],
			"parent_id": "a7f0ba9f-a91a-4924-8447-b93845e6da1c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a7f0ba9f-a91a-4924-8447-b93845e6da1c",
			"type": "page",
			"properties": {
				"title": [
					[
						"Paradigm"
					]
				]
			},
			"content": [
				"d4e0a1ac-e02e-4158-9d96-534ae9fa2c53",
				"b091b55a-a32c-4567-82d7-65c50636e3a7",
				"4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
				"7adbd680-541d-4e6e-97d1-f277bd1610c0",
				"ec15c567-4038-4c10-81bb-0a86aee56b08",
				"9a57d34b-41d2-40e4-8c4d-132953b7a175",
				"da552996-155b-442f-9ecf-0bdce521a35e",
				"1f51d543-236b-4b29-a278-4bed543f50b5",
				"5f304e57-18f8-4cd9-b80b-07951787740a",
				"f5097b73-1152-4e95-8919-54eed014af82",
				"94cd6ab9-c518-4094-829c-36d8a73e8010",
				"88cf99fd-dc9d-4649-8601-eb5198351e06",
				"d21336ae-ecfc-4130-a757-19109a89ad74",
				"e916c9a3-5983-4c34-bec3-187e417c593c",
				"cd7c41d2-ae59-4c69-b7d6-4254cf727ff5",
				"7ba8f4fe-6d71-4e1f-a1eb-1df9e3da0099",
				"31c9a6bd-328b-4869-aecd-fabd86f3cf15",
				"cb2b1b2c-b795-4abf-b11f-772b33e43908",
				"a47c1d35-578a-4679-8907-d8b13ab1bb65",
				"41e2749d-ddd3-4a06-b224-0ae6b4c9d436",
				"c3e7c6b7-650d-456d-8997-a4d049587d58",
				"7472c506-f9da-4f2e-85ba-59623551e747",
				"16b738c5-499f-42a0-baf4-cffb990a0b25",
				"51181f46-f9ad-4d25-b2c3-a59f7c7b8587",
				"e8ea6408-fc0d-4be8-8020-e982cc7c9b55",
				"3143e3ff-a6eb-4e48-8197-d96fceb48f9e",
				"20802187-e25a-4d38-af64-a363ffcace1d",
				"311c23ba-4ac6-48a0-bf3b-de8b115c363f",
				"aec03706-7113-42af-8724-4b446502d53a",
				"4836526c-ce6a-4bfd-8c2f-4bcb9a446e1e",
				"e0b8f319-a947-4c5d-8bdf-cd0ffeea5a6d",
				"aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
				"98a66dbd-731e-498f-9c5f-7790d1f555e0",
				"c7ec9e06-de22-4861-88e6-e6d45e0de285",
				"55690b50-0664-4442-9ded-4645f2f318e9"
			],
			"parent_id": "1fcd74a2-648f-4dfc-a4d8-abbb9a7bfb29",
			"parent_table": "team",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "cc4617c1-0f91-4b55-b2c0-45951974a57c",
			"type": "code",
			"properties": {
				"title": [
					[
						"<meta type=\"url\" value=\"/voice_and_tone/easy\"/>"
					]
				],
				"language": [
					[
						"JavaScript"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "59965235-a5bf-47ab-a373-a550ce0256e7",
					"table": "block",
					"spaceId": "22066aad-9295-4afc-88d1-dae5d26fea31"
				}
			},
			"parent_id": "e916c9a3-5983-4c34-bec3-187e417c593c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "5ec53dbc-b92e-44ef-94c1-48cdc837607e",
			"type": "text",
			"properties": {
				"title": [
					[
						"Наши пользователи — миллионы людей по всему миру.\nНам важно быть понятным, удобным, полезным и человечным сервисом для людей разных национальностей, возрастов, культурных особенностей."
					]
				]
			},
			"parent_id": "e916c9a3-5983-4c34-bec3-187e417c593c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "928f3ae0-7d34-4447-9d27-8d672ca1d4e1",
			"type": "text",
			"properties": {
				"title": [
					[
						"Поэтому мы:"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "7b66cb8b-d4b4-48cf-be56-493752a2acd7",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "e916c9a3-5983-4c34-bec3-187e417c593c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "7bf75ea7-a3cf-47a1-9c4a-ecb412e77b84",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"объясняем сложное"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "cb32f4c9-a4e1-4103-ba61-ae91791a8ba3",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "e916c9a3-5983-4c34-bec3-187e417c593c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "17b36a19-a996-4632-8fdd-1278997bbdc1",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"звучим человечно"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "185da83b-1205-46f4-b39a-48932e3d6ebd",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "e916c9a3-5983-4c34-bec3-187e417c593c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "fb7f94c5-9a95-4ec0-b7c2-00ecf0819328",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"строим коммуникацию на равных"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "b0e91f8a-7adc-4f62-8d85-3d41091acf52",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "e916c9a3-5983-4c34-bec3-187e417c593c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "916ffdab-ca2f-4964-b0ba-968ab34de1d9",
			"type": "header",
			"properties": {
				"title": [
					[
						"Канцеляризмы "
					]
				]
			},
			"parent_id": "e916c9a3-5983-4c34-bec3-187e417c593c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "93d06b98-b4c8-4100-83eb-d6ac3df8dc07",
			"type": "text",
			"properties": {
				"title": [
					[
						"«В установленном порядке», «убедительная просьба», «в связи» и т. д. — от этих фраз веет сложным, бюрократическим, «мёртвым» языком. Они утяжеляют, не помогают, отпугивают. Говорить стоит по-человечески. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "56ddd640-9ac9-47ed-95a7-62560726293f",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "e916c9a3-5983-4c34-bec3-187e417c593c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "487c9f61-b59d-4ad3-9521-ab032644efbb",
			"type": "column_list",
			"content": [
				"128b2490-97a5-4643-ab2e-2c3e093c02cc",
				"4fc215df-ff0f-4d38-b91a-37e35bbb811b"
			],
			"format": {
				"copied_from_pointer": {
					"id": "2d9c5eea-7435-4db0-b4c1-1e6d76a8c707",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "e916c9a3-5983-4c34-bec3-187e417c593c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "f52a03f6-3fc8-453f-b867-55103b76c639",
			"type": "header",
			"properties": {
				"title": [
					[
						"Клише "
					]
				]
			},
			"parent_id": "e916c9a3-5983-4c34-bec3-187e417c593c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ea881711-5a72-45a7-a7d2-c8efdd5d87cf",
			"type": "text",
			"properties": {
				"title": [
					[
						"Клише, как и канцеляризмы — «мёртвые» слова. В них нет пользы, они путают, пугают и отвращают человека от действия."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "8281864e-ce5f-4c1a-83d1-58370d4b7f09",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "e916c9a3-5983-4c34-bec3-187e417c593c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "aaf0a349-1403-4b93-a79a-cfa1e3a4bd9e",
			"type": "column_list",
			"content": [
				"3221c49d-0c0b-4df5-b0e8-3e9cd8204eb5",
				"c96a0287-d5d2-4bdb-8e8f-06513ab353c8"
			],
			"format": {
				"copied_from_pointer": {
					"id": "a9580134-d3f8-49fc-a24d-01c61be1d087",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "e916c9a3-5983-4c34-bec3-187e417c593c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "72745913-9f75-4f67-a382-e64f7cbd0efd",
			"type": "header",
			"properties": {
				"title": [
					[
						"Терминология "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "9e438d2b-2858-434b-a359-ee5aa3c427b6",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "e916c9a3-5983-4c34-bec3-187e417c593c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "fff625a0-c310-4551-a188-a6f6ad25ac0e",
			"type": "text",
			"properties": {
				"title": [
					[
						"Профессиональные, юридические или технические термины и выражения делают текст сложным для восприятия, утяжеляют его и путают читателя. Ищем замену, которая будет понятна обычному человеку, или объясняем значение. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "8d1a9ed2-fc1d-4e74-8f6e-23b63a1a0882",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "e916c9a3-5983-4c34-bec3-187e417c593c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "f76d8a69-ea9e-4996-b288-a1059f8f90d4",
			"type": "column_list",
			"content": [
				"45e03b59-b909-4bc0-bbbf-de2d761450ad",
				"2ef6cc50-7d61-49a5-b9b3-fd33b010b44e"
			],
			"format": {
				"copied_from_pointer": {
					"id": "87fae64a-0a3e-4c94-ac05-4bc225235b14",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "e916c9a3-5983-4c34-bec3-187e417c593c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "c2ab34e8-76b4-4eeb-a457-03090a9cc536",
			"type": "header",
			"properties": {
				"title": [
					[
						"Цепочка родительных"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "445b0ca1-098e-4c26-9fa5-ffdda14b751e",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "e916c9a3-5983-4c34-bec3-187e417c593c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "dd89bf51-c88b-4212-9813-2f94e08d2584",
			"type": "text",
			"properties": {
				"title": [
					[
						"Несколько слов в родительном падеже, которые стоят друг за другом, путают человека. В таких фразах сложно понять, кто или что — главное, а что — второстепенное. Такой клубок распутываем, указываем главное действующее лицо. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "3e70f5a0-6c52-4db9-8aad-5c8df4ecd4d1",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "e916c9a3-5983-4c34-bec3-187e417c593c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "816a2b0b-130e-43bc-90b5-1eba8ea1d440",
			"type": "column_list",
			"content": [
				"ab28f493-af61-4d44-b5ce-92021b460fc4",
				"c70b27da-bf60-45fd-b44b-af65a7a377db"
			],
			"format": {
				"copied_from_pointer": {
					"id": "4ef77415-a4ec-4f3a-b80c-7edb4e999d8c",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "e916c9a3-5983-4c34-bec3-187e417c593c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "361bcc88-23d5-466a-87cb-5cf935a9df44",
			"type": "header",
			"properties": {
				"title": [
					[
						"Отглагольные и глаголы на -тся"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "220080c3-f0c4-486c-8fd4-8f7a9098d617",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "e916c9a3-5983-4c34-bec3-187e417c593c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "6c3b19de-c6c9-40d5-8052-ab09f496599f",
			"type": "text",
			"properties": {
				"title": [
					[
						"Глагол делает фразу сильнее. В ней появляется динамика и действие — стараемся использовать именно его. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "9c64055f-3b62-47bf-98d8-037267ffefb5",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "e916c9a3-5983-4c34-bec3-187e417c593c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "dfd68174-a8f8-4104-9471-706d68ee593a",
			"type": "text",
			"properties": {
				"title": [
					[
						"Исключения ",
						[
							[
								"b"
							]
						]
					],
					[
						"\nСервисные сообщения, когда мы точно можем сказать, что отглагольное — это действие системы. Например: письмо отправлено, файл удалён"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "a6c2f948-47eb-4714-9ce4-c504a76621fc",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "e916c9a3-5983-4c34-bec3-187e417c593c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "326899f1-f77b-4fef-97da-76f12df4a964",
			"type": "column_list",
			"content": [
				"92ee2387-5396-4972-9e64-192345bb8120",
				"486264ca-e578-4a54-8c51-c8f3cc95ad41"
			],
			"format": {
				"copied_from_pointer": {
					"id": "87e572fb-bb5a-4b97-ad14-e67ba8fe0e6e",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "e916c9a3-5983-4c34-bec3-187e417c593c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "48b790b0-832d-47d0-95b6-6927439de720",
			"type": "header",
			"properties": {
				"title": [
					[
						"Причастные и деепричастные обороты"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "0860593d-ed19-4d91-bd2b-3c75d988da5c",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "e916c9a3-5983-4c34-bec3-187e417c593c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b81cd1f6-479d-4376-a67d-7ab3784587c3",
			"type": "text",
			"properties": {
				"title": [
					[
						"Путают и уводят от главной мысли. Клубок стоит распутать и смело указать на того, кто выполняет основное действие. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "87159186-b937-4d92-b08f-29b7907045f6",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "e916c9a3-5983-4c34-bec3-187e417c593c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b3b6e0da-d07d-40f5-ba86-8062752eef4d",
			"type": "text",
			"properties": {
				"title": [
					[
						"При этом, не будьте категоричны — формулировка: Нажимая «Далее», вы принимаете... — самая короткая и её можно использовать.   "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "547553fd-195e-4c82-b000-e9d56e8397c8",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "e916c9a3-5983-4c34-bec3-187e417c593c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "1f57704d-6a51-4588-a2fe-773c735386bf",
			"type": "column_list",
			"content": [
				"eec1e696-0513-4c03-a6da-62fca215d60e",
				"903adc0c-1331-4c15-a1c2-657b86b65cc9"
			],
			"format": {
				"copied_from_pointer": {
					"id": "7c0ffa11-a70e-4af3-a3b9-ae75506e38f0",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "e916c9a3-5983-4c34-bec3-187e417c593c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "9b4229c0-0d72-460d-87d0-e1c6cd975286",
			"type": "header",
			"properties": {
				"title": [
					[
						"На «вы» и с маленькой буквы"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "307dd745-6b57-40d5-a67b-1c14ed118e15",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "e916c9a3-5983-4c34-bec3-187e417c593c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "39c7c837-f926-4824-8ff0-fbab227c235b",
			"type": "text",
			"properties": {
				"title": [
					[
						"Мы обращаемся к пользователям на «вы», но всегда с маленькой буквы. Вы, Вам, Ваш — это лишнее расшаркивание, мы априори выстраиваем уважительные отношения и большая буква не придаёт им больший вес."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "24206ca9-f388-4dd4-b48f-425790ba7c63",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "e916c9a3-5983-4c34-bec3-187e417c593c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "fa017015-8311-4496-8a0d-913d868570d0",
			"type": "text",
			"properties": {
				"title": [
					[
						"«Ты» — панибратство. Обращение на «ты» может возникнуть только в продукте, который рассчитан на молодую аудиторию, например, в Детской почте. То есть «ты» может быть вшито в tone of voice конкретного продукта или проекта. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "c277b2d9-91f0-4236-a0e1-ae934f5cdbf5",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "e916c9a3-5983-4c34-bec3-187e417c593c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "cfd23cf5-5533-4149-b6f1-2c6ea86ae040",
			"type": "column_list",
			"content": [
				"c747ac76-5510-452b-90a3-74eb09b547fb",
				"2aace324-bc9a-4430-bb1a-f1385b083fd2"
			],
			"format": {
				"copied_from_pointer": {
					"id": "fd06da64-d3ca-41eb-8259-b1e50c2db282",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "e916c9a3-5983-4c34-bec3-187e417c593c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b59f1e21-862e-47c0-90db-c7def32d7112",
			"type": "header",
			"properties": {
				"title": [
					[
						"Уважаемый! "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "3e1a3926-b714-42cf-9081-fcb550fa396a",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "e916c9a3-5983-4c34-bec3-187e417c593c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "e91be86a-90df-437e-a48e-744dc3dc7a8d",
			"type": "text",
			"properties": {
				"title": [
					[
						"Эта фраза давно стала «белым шумом». В ней нет уважения, но есть обезличивание и псевдозабота. Выберите вариант:"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "4bafbed5-b63f-4220-bbdc-342964d645f6",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "e916c9a3-5983-4c34-bec3-187e417c593c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "bcb6d40e-5a48-4f23-9d99-a4fab9669180",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"если обращение массовое — начать стоит сразу с его сути"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "274e37ba-d19f-46cd-b133-ef46d60b5fb7",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "e916c9a3-5983-4c34-bec3-187e417c593c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "502ec16b-cd79-4108-9f8c-2588337fe612",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"если обращение персональное и мы знаем имя — обращаемся по имени или переходим сразу к сути"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "d951379e-a219-40ff-91cd-65d710bcaf68",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "e916c9a3-5983-4c34-bec3-187e417c593c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "5eae1602-464e-49a2-a50f-8488eeb3f3a3",
			"type": "column_list",
			"content": [
				"81ff62a2-23bb-476d-82cc-2da148f0d192",
				"1a477652-c514-4ce6-8af3-a01e21d41a48"
			],
			"format": {
				"copied_from_pointer": {
					"id": "c8f43d7f-36c0-415b-9390-20caa5798e09",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "e916c9a3-5983-4c34-bec3-187e417c593c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "218e76a5-3577-4267-be42-aad8b069b42b",
			"type": "header",
			"properties": {
				"title": [
					[
						"Аббревиатуры, сокращения, англицизмы "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "8f3dfcf2-3f4c-4c92-bf05-c489a4651df0",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "e916c9a3-5983-4c34-bec3-187e417c593c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "5cf3aa65-e1e3-4a70-a8cb-ad4414bf425a",
			"type": "text",
			"properties": {
				"title": [
					[
						"Иногда нам кажется, что пользователь и так знает, что означает та или иная аббревиатура. И мы заблуждаемся. Если сокращение не общепринятое, например: ИП, ЗАО, АПК, НДС и т. д., то единожды по тексту стоит дать расшифровку или объяснить, как это работает. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "812a1d44-330b-4d73-8779-c30dcd062cff",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "e916c9a3-5983-4c34-bec3-187e417c593c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "744867c2-afd1-46cb-83bb-132b4a7db315",
			"type": "text",
			"properties": {
				"title": [
					[
						"Англицизмы — конечно, допустимы, но только тогда, когда мы уверены, что слово понятно. Если не уверены — идём проверять с помощью немодерируемого теста в Pathway или обращаемся к опыту UX-лаборатории. А ещё, можно проверить частотность использования в "
					],
					[
						"Google Trends",
						[
							[
								"a",
								"https://trends.google.ru/trends/",
								true
							]
						]
					],
					[
						". "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "511c970b-8613-49f1-beba-0b9281394a78",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "e916c9a3-5983-4c34-bec3-187e417c593c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "37b066a8-29c2-478c-8eb5-102eb7384bed",
			"type": "column_list",
			"content": [
				"d57020dd-332c-425c-bf08-19e2d6f45d85",
				"caa5eca3-7718-443e-b4b8-7b50706fb5b5"
			],
			"format": {
				"copied_from_pointer": {
					"id": "d56f494e-f236-414a-a31e-6e08cb9113cb",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "e916c9a3-5983-4c34-bec3-187e417c593c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "290b78a6-8309-41fe-9ab9-f1d3c6e16662",
			"type": "header",
			"properties": {
				"title": [
					[
						"Длинные тексты "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "0547e98c-dd5e-4e41-b201-faa373b7effa",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "e916c9a3-5983-4c34-bec3-187e417c593c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "7c3e71db-3010-4f1f-ab6f-499f7923ec3a",
			"type": "text",
			"properties": {
				"title": [
					[
						"Экономим время человека и место в интерфейсе. Говорим заботливо и с пользой, но при этом лаконично. В коротких форматах стараемся не выходить за пределы 2-3 строк — например, в блоках дайджестов, баннерах. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "139cc274-61db-473a-8c72-c211156b2e5f",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "e916c9a3-5983-4c34-bec3-187e417c593c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "bc39034e-2c64-44bc-a3db-f38ab00c27fd",
			"type": "column_list",
			"content": [
				"62a34664-5d28-47f8-81de-ffbb27f954e3",
				"015b9642-bbff-49f3-a799-e54b7a5b92cc"
			],
			"format": {
				"copied_from_pointer": {
					"id": "477fb150-49a2-4034-8072-c25d727b9e1a",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "e916c9a3-5983-4c34-bec3-187e417c593c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "128b2490-97a5-4643-ab2e-2c3e093c02cc",
			"type": "column",
			"content": [
				"2fd613e9-3c75-4670-a547-3064b3cf28dd",
				"efc7c700-8784-4350-a1d8-2b0b7d1ca094"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "7db9d159-e628-474c-bb94-eb8ed8c4aee3",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "487c9f61-b59d-4ad3-9521-ab032644efbb",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "4fc215df-ff0f-4d38-b91a-37e35bbb811b",
			"type": "column",
			"content": [
				"00b2590c-79ad-49da-9033-bf55587dc3ec",
				"20ddf5d6-c89b-4945-ba6c-df192eda6051"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "932951d4-7e6b-404a-8cab-de21252b7d43",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "487c9f61-b59d-4ad3-9521-ab032644efbb",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "2fd613e9-3c75-4670-a547-3064b3cf28dd",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/e09f0b69-90b2-4d01-9c9c-005c0ed45813/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/e09f0b69-90b2-4d01-9c9c-005c0ed45813/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "128b2490-97a5-4643-ab2e-2c3e093c02cc",
			"parent_table": "block",
			"file_ids": [
				"e09f0b69-90b2-4d01-9c9c-005c0ed45813"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/2fd613e9-3c75-4670-a547-3064b3cf28dd.png"
		},
		{
			"id": "efc7c700-8784-4350-a1d8-2b0b7d1ca094",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Вы подписали соглашение \n\nОтправьте документы \n\nОплатите "
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "0e60a1b9-730e-4a74-9e38-6949d97acc9c",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "128b2490-97a5-4643-ab2e-2c3e093c02cc",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "00b2590c-79ad-49da-9033-bf55587dc3ec",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/181be47c-1a6c-4abe-964e-be39257f0d4a/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/181be47c-1a6c-4abe-964e-be39257f0d4a/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "4fc215df-ff0f-4d38-b91a-37e35bbb811b",
			"parent_table": "block",
			"file_ids": [
				"181be47c-1a6c-4abe-964e-be39257f0d4a"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/00b2590c-79ad-49da-9033-bf55587dc3ec.png"
		},
		{
			"id": "20ddf5d6-c89b-4945-ba6c-df192eda6051",
			"type": "callout",
			"properties": {
				"title": [
					[
						"На основании соглашения \n\nПредоставьте документы \n\nПройдите процедуру оплаты "
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "bc68a581-ed1a-46b6-a0b6-d1bc75e11e23",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "4fc215df-ff0f-4d38-b91a-37e35bbb811b",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "3221c49d-0c0b-4df5-b0e8-3e9cd8204eb5",
			"type": "column",
			"content": [
				"111858ff-9162-4f60-b12b-e62e0264c234",
				"ff8415ed-0cb1-4efe-b278-678f21712e5b"
			],
			"format": {
				"column_ratio": 0.49999999999999994,
				"copied_from_pointer": {
					"id": "639b537c-50dc-4ef1-bcc8-a40192b995e5",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "aaf0a349-1403-4b93-a79a-cfa1e3a4bd9e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "c96a0287-d5d2-4bdb-8e8f-06513ab353c8",
			"type": "column",
			"content": [
				"5245a53e-afb0-4c98-bd2a-424171f5c5da",
				"965444fa-b4fd-45eb-982b-4168bf76a356"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "1eac0d09-7852-4d2a-bbf6-2f2057abfef9",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "aaf0a349-1403-4b93-a79a-cfa1e3a4bd9e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "111858ff-9162-4f60-b12b-e62e0264c234",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/8ec67d23-0246-4090-bb17-572f2ddf1f9a/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/8ec67d23-0246-4090-bb17-572f2ddf1f9a/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "3221c49d-0c0b-4df5-b0e8-3e9cd8204eb5",
			"parent_table": "block",
			"file_ids": [
				"8ec67d23-0246-4090-bb17-572f2ddf1f9a"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/111858ff-9162-4f60-b12b-e62e0264c234.png"
		},
		{
			"id": "ff8415ed-0cb1-4efe-b278-678f21712e5b",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Что полезного в наших сервисах: 1, 2, 3\n\nМожно скачать\n\nПридумайте пароль"
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "0ddfa59b-94fd-430b-95f0-88c598c18383",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "3221c49d-0c0b-4df5-b0e8-3e9cd8204eb5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "5245a53e-afb0-4c98-bd2a-424171f5c5da",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/731b4cf7-7ba9-48a9-a62c-d448f54a5311/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/731b4cf7-7ba9-48a9-a62c-d448f54a5311/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "c96a0287-d5d2-4bdb-8e8f-06513ab353c8",
			"parent_table": "block",
			"file_ids": [
				"731b4cf7-7ba9-48a9-a62c-d448f54a5311"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/5245a53e-afb0-4c98-bd2a-424171f5c5da.png"
		},
		{
			"id": "965444fa-b4fd-45eb-982b-4168bf76a356",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Оцените преимущества\n\nДоступно для скачивания \n\nНеобходимо придумать пароль "
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "91a3e031-ae77-4265-aaee-d3ce5e22ebee",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "c96a0287-d5d2-4bdb-8e8f-06513ab353c8",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "45e03b59-b909-4bc0-bbbf-de2d761450ad",
			"type": "column",
			"content": [
				"904e02aa-9adb-45f9-8900-1a1cd99f9f26",
				"bea814d9-d59c-4065-9ecd-dd5e240b934a"
			],
			"format": {
				"column_ratio": 0.49999999999999994,
				"copied_from_pointer": {
					"id": "9c44e6bc-e50b-48bc-bf0d-e84fdb6691db",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "f76d8a69-ea9e-4996-b288-a1059f8f90d4",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "2ef6cc50-7d61-49a5-b9b3-fd33b010b44e",
			"type": "column",
			"content": [
				"71e2c2b5-1e36-4405-b9ae-bf06f5e969de",
				"0d7b0190-5b13-4d4e-9ec1-5aeb1c73070b"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "a6c72376-9960-4758-bcf2-8914ecc67f11",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "f76d8a69-ea9e-4996-b288-a1059f8f90d4",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "904e02aa-9adb-45f9-8900-1a1cd99f9f26",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/a9bf30a4-f264-45c3-8a1c-89be2df01697/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/a9bf30a4-f264-45c3-8a1c-89be2df01697/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "45e03b59-b909-4bc0-bbbf-de2d761450ad",
			"parent_table": "block",
			"file_ids": [
				"a9bf30a4-f264-45c3-8a1c-89be2df01697"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/904e02aa-9adb-45f9-8900-1a1cd99f9f26.png"
		},
		{
			"id": "bea814d9-d59c-4065-9ecd-dd5e240b934a",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Письмо с предложением \nо работе \n\n…скопируйте \n\nСсылка на звонок  "
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "69f3a75a-ddd5-40ae-8dd2-a4337217a74f",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "45e03b59-b909-4bc0-bbbf-de2d761450ad",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "71e2c2b5-1e36-4405-b9ae-bf06f5e969de",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/3fbd1144-8cd3-4618-b750-a0b5689de675/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/3fbd1144-8cd3-4618-b750-a0b5689de675/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "2ef6cc50-7d61-49a5-b9b3-fd33b010b44e",
			"parent_table": "block",
			"file_ids": [
				"3fbd1144-8cd3-4618-b750-a0b5689de675"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/71e2c2b5-1e36-4405-b9ae-bf06f5e969de.png"
		},
		{
			"id": "0d7b0190-5b13-4d4e-9ec1-5aeb1c73070b",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Письмо с оффером\n\n...далее сделайте копипаст\n\nСсылка для CalDav"
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "979d7a3e-d8c6-411a-959a-c51a6c450c31",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "2ef6cc50-7d61-49a5-b9b3-fd33b010b44e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ab28f493-af61-4d44-b5ce-92021b460fc4",
			"type": "column",
			"content": [
				"b2e1bc91-3956-45ae-b1e1-db3944309e83",
				"e96b3067-e4a9-4e7e-a95c-a85d5bd923bb"
			],
			"format": {
				"column_ratio": 0.49999999999999994,
				"copied_from_pointer": {
					"id": "8258ab04-9a40-49e1-b0e5-5b18d671d251",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "816a2b0b-130e-43bc-90b5-1eba8ea1d440",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "c70b27da-bf60-45fd-b44b-af65a7a377db",
			"type": "column",
			"content": [
				"9c19b86c-47bd-4b15-9f4e-b0ee40aab1fa",
				"d9bc222a-6d70-4175-a83a-f2edc3d22ce0"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "0f31da27-f51d-4fe2-a6c6-6769f8cc214d",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "816a2b0b-130e-43bc-90b5-1eba8ea1d440",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b2e1bc91-3956-45ae-b1e1-db3944309e83",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/dd3fa686-bdb4-46bc-b732-8b38be6ca0b2/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/dd3fa686-bdb4-46bc-b732-8b38be6ca0b2/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "ab28f493-af61-4d44-b5ce-92021b460fc4",
			"parent_table": "block",
			"file_ids": [
				"dd3fa686-bdb4-46bc-b732-8b38be6ca0b2"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/b2e1bc91-3956-45ae-b1e1-db3944309e83.png"
		},
		{
			"id": "e96b3067-e4a9-4e7e-a95c-a85d5bd923bb",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Ссылка действует до 5 января, 23:00   "
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "0370a9df-7661-43c6-83c8-b29a9ce975ce",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "ab28f493-af61-4d44-b5ce-92021b460fc4",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "9c19b86c-47bd-4b15-9f4e-b0ee40aab1fa",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/db715857-5788-46eb-a10c-df49e9ddf203/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 688,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/db715857-5788-46eb-a10c-df49e9ddf203/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "c70b27da-bf60-45fd-b44b-af65a7a377db",
			"parent_table": "block",
			"file_ids": [
				"db715857-5788-46eb-a10c-df49e9ddf203"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/9c19b86c-47bd-4b15-9f4e-b0ee40aab1fa.png"
		},
		{
			"id": "d9bc222a-6d70-4175-a83a-f2edc3d22ce0",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Ссылка активна до окончания периода действия "
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "c1743704-a2a0-46ae-9de4-9b3cf356b9b3",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "c70b27da-bf60-45fd-b44b-af65a7a377db",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "92ee2387-5396-4972-9e64-192345bb8120",
			"type": "column",
			"content": [
				"ee0937c7-4866-41e0-9bcb-75bef7aa7f98",
				"aabb9e0d-eefa-44a6-8bc0-2adaafc5f28d"
			],
			"format": {
				"column_ratio": 0.49999999999999994,
				"copied_from_pointer": {
					"id": "589126c9-224c-4460-aa9f-df6c193767c7",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "326899f1-f77b-4fef-97da-76f12df4a964",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "486264ca-e578-4a54-8c51-c8f3cc95ad41",
			"type": "column",
			"content": [
				"8a4a9ced-b69c-4f24-9e38-93d26215ffef",
				"2829fff6-efe1-47f0-b2a5-5b552c1afbba"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "d49a50df-dd63-4e34-9e9d-4e1a87b035b8",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "326899f1-f77b-4fef-97da-76f12df4a964",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ee0937c7-4866-41e0-9bcb-75bef7aa7f98",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/dba1f7d4-5ea2-46d6-a5b3-febae77fc289/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/dba1f7d4-5ea2-46d6-a5b3-febae77fc289/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "92ee2387-5396-4972-9e64-192345bb8120",
			"parent_table": "block",
			"file_ids": [
				"dba1f7d4-5ea2-46d6-a5b3-febae77fc289"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/ee0937c7-4866-41e0-9bcb-75bef7aa7f98.png"
		},
		{
			"id": "aabb9e0d-eefa-44a6-8bc0-2adaafc5f28d",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Вы можете отправить вложения\n\nВы удаляете время встречи \n\nВы отправите письмо   "
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "b0a244fc-654a-44c7-a436-99ef046b6ca3",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "92ee2387-5396-4972-9e64-192345bb8120",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "8a4a9ced-b69c-4f24-9e38-93d26215ffef",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/b49ebd57-6542-4041-8244-b9cfd1e180b1/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/b49ebd57-6542-4041-8244-b9cfd1e180b1/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "486264ca-e578-4a54-8c51-c8f3cc95ad41",
			"parent_table": "block",
			"file_ids": [
				"b49ebd57-6542-4041-8244-b9cfd1e180b1"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/8a4a9ced-b69c-4f24-9e38-93d26215ffef.png"
		},
		{
			"id": "2829fff6-efe1-47f0-b2a5-5b552c1afbba",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Вложения будут отправляться\n\nПредложение времени будет удалено  \n\nПисьмо сразу отправится "
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "d093d333-9190-48f0-8d22-a061508a3070",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "486264ca-e578-4a54-8c51-c8f3cc95ad41",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "eec1e696-0513-4c03-a6da-62fca215d60e",
			"type": "column",
			"content": [
				"0c0359a4-a176-4e8a-ad66-613122284c19",
				"9b991e6d-f91b-4838-93e1-58b3b781c0bc"
			],
			"format": {
				"column_ratio": 0.49999999999999994,
				"copied_from_pointer": {
					"id": "69eff19f-a7dc-4ac9-b5ea-9993f33d6583",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "1f57704d-6a51-4588-a2fe-773c735386bf",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "903adc0c-1331-4c15-a1c2-657b86b65cc9",
			"type": "column",
			"content": [
				"2baea404-a5b0-469c-9853-00c5badea01c",
				"03744ffd-7e9d-4690-b2c9-1a6dc5e0774c"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "12fefc4a-a248-453d-8f29-39149343f3ae",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "1f57704d-6a51-4588-a2fe-773c735386bf",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "0c0359a4-a176-4e8a-ad66-613122284c19",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/cf6b2516-f1fb-4302-ac7e-f0bf9a087e51/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/cf6b2516-f1fb-4302-ac7e-f0bf9a087e51/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "eec1e696-0513-4c03-a6da-62fca215d60e",
			"parent_table": "block",
			"file_ids": [
				"cf6b2516-f1fb-4302-ac7e-f0bf9a087e51"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/0c0359a4-a176-4e8a-ad66-613122284c19.png"
		},
		{
			"id": "9b991e6d-f91b-4838-93e1-58b3b781c0bc",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Чтобы продолжить работу \nна сайте, нужно согласиться   "
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "ab48d757-992e-484a-b01d-5f3fe9a46598",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "eec1e696-0513-4c03-a6da-62fca215d60e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "2baea404-a5b0-469c-9853-00c5badea01c",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/88395fc5-f2cc-4be1-99f9-c928d190c65b/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/88395fc5-f2cc-4be1-99f9-c928d190c65b/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "903adc0c-1331-4c15-a1c2-657b86b65cc9",
			"parent_table": "block",
			"file_ids": [
				"88395fc5-f2cc-4be1-99f9-c928d190c65b"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/2baea404-a5b0-469c-9853-00c5badea01c.png"
		},
		{
			"id": "03744ffd-7e9d-4690-b2c9-1a6dc5e0774c",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Используя сайт, \nвы соглашаетесь "
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "018240d8-228a-4e85-aff3-20a1d5200bea",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "903adc0c-1331-4c15-a1c2-657b86b65cc9",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "c747ac76-5510-452b-90a3-74eb09b547fb",
			"type": "column",
			"content": [
				"d1dabb20-8a55-4d32-8986-71f77b0046f9",
				"2181ac8a-6c7e-497e-995f-bf275c73e32c"
			],
			"format": {
				"column_ratio": 0.49999999999999994,
				"copied_from_pointer": {
					"id": "ce020e1c-0135-4b25-acf6-990644a9a3b1",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cfd23cf5-5533-4149-b6f1-2c6ea86ae040",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "2aace324-bc9a-4430-bb1a-f1385b083fd2",
			"type": "column",
			"content": [
				"bd342b78-2249-4afa-92e2-99d40041a9c1",
				"4800b00f-e313-4419-9ef3-0bcae17f2f4d"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "88949291-54e9-4a2d-89f0-74f96ddeebfc",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cfd23cf5-5533-4149-b6f1-2c6ea86ae040",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "d1dabb20-8a55-4d32-8986-71f77b0046f9",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/9fc02dc6-72b8-490f-9b71-d2047e37801f/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/9fc02dc6-72b8-490f-9b71-d2047e37801f/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "c747ac76-5510-452b-90a3-74eb09b547fb",
			"parent_table": "block",
			"file_ids": [
				"9fc02dc6-72b8-490f-9b71-d2047e37801f"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/d1dabb20-8a55-4d32-8986-71f77b0046f9.png"
		},
		{
			"id": "2181ac8a-6c7e-497e-995f-bf275c73e32c",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Как вам Почта? \n\nСпасибо за обратную связь"
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "0ce153c0-3861-41fe-b539-a44d5b3e511c",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "c747ac76-5510-452b-90a3-74eb09b547fb",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "bd342b78-2249-4afa-92e2-99d40041a9c1",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/37adc3fb-49b8-47c5-be45-2274830d4357/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/37adc3fb-49b8-47c5-be45-2274830d4357/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "2aace324-bc9a-4430-bb1a-f1385b083fd2",
			"parent_table": "block",
			"file_ids": [
				"37adc3fb-49b8-47c5-be45-2274830d4357"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/bd342b78-2249-4afa-92e2-99d40041a9c1.png"
		},
		{
			"id": "4800b00f-e313-4419-9ef3-0bcae17f2f4d",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Оцени Почту \n\nМы ценим Вашу обратную связь"
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "17c2331f-436e-4602-8a2b-241ea1a8a113",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "2aace324-bc9a-4430-bb1a-f1385b083fd2",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "81ff62a2-23bb-476d-82cc-2da148f0d192",
			"type": "column",
			"content": [
				"579eafc4-7d67-472c-8582-e17b6db13ec7",
				"66d95b33-b018-42af-b255-8f81643d9637"
			],
			"format": {
				"column_ratio": 0.49999999999999994,
				"copied_from_pointer": {
					"id": "02e7bb47-b6c2-4e16-a55f-2340370dae55",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "5eae1602-464e-49a2-a50f-8488eeb3f3a3",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "1a477652-c514-4ce6-8af3-a01e21d41a48",
			"type": "column",
			"content": [
				"ffb01b4a-8818-4f01-8ebf-7e6e975e31d3",
				"d67285e5-fb7f-4af0-a186-d168bd09b334"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "d4fdf2b0-407c-428b-9a80-661508296be3",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "5eae1602-464e-49a2-a50f-8488eeb3f3a3",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "579eafc4-7d67-472c-8582-e17b6db13ec7",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/11be1744-4146-4331-8b69-420ba7889ff7/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/11be1744-4146-4331-8b69-420ba7889ff7/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "81ff62a2-23bb-476d-82cc-2da148f0d192",
			"parent_table": "block",
			"file_ids": [
				"11be1744-4146-4331-8b69-420ba7889ff7"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/579eafc4-7d67-472c-8582-e17b6db13ec7.png"
		},
		{
			"id": "66d95b33-b018-42af-b255-8f81643d9637",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Ирина, здравствуйте!  \n\nПриложение сейчас недоступно. Обновите страницу чуть позже "
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "2598e36e-64e3-469b-8649-1052f25e5dba",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "81ff62a2-23bb-476d-82cc-2da148f0d192",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ffb01b4a-8818-4f01-8ebf-7e6e975e31d3",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/b2bf7720-2f05-4542-8074-c25a25afde65/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/b2bf7720-2f05-4542-8074-c25a25afde65/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "1a477652-c514-4ce6-8af3-a01e21d41a48",
			"parent_table": "block",
			"file_ids": [
				"b2bf7720-2f05-4542-8074-c25a25afde65"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/ffb01b4a-8818-4f01-8ebf-7e6e975e31d3.png"
		},
		{
			"id": "d67285e5-fb7f-4af0-a186-d168bd09b334",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Уважаемый друг! \n\nУважаемые пользователи! Приложение недоступно "
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "f1b70a6f-ec94-4543-9fd5-72d18c2ab771",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "1a477652-c514-4ce6-8af3-a01e21d41a48",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "d57020dd-332c-425c-bf08-19e2d6f45d85",
			"type": "column",
			"content": [
				"6e75e9a2-b870-455b-b16d-90d102a667a8",
				"af0daa2c-e449-455c-9a1a-82d5e69fa01e"
			],
			"format": {
				"column_ratio": 0.49999999999999994,
				"copied_from_pointer": {
					"id": "8db586ed-971a-460a-9ff9-64174d8b7435",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "37b066a8-29c2-478c-8eb5-102eb7384bed",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "caa5eca3-7718-443e-b4b8-7b50706fb5b5",
			"type": "column",
			"content": [
				"8718b0d8-318e-4bfb-aa2f-c33e4d66b278",
				"23eab659-30fd-443a-a9dd-1fe487a52dd5"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "8ad7ff5a-3819-41cd-9c5b-5837ce95a61e",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "37b066a8-29c2-478c-8eb5-102eb7384bed",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "6e75e9a2-b870-455b-b16d-90d102a667a8",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/21191c22-d2fa-400b-afaa-e7fcf9843d9d/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/21191c22-d2fa-400b-afaa-e7fcf9843d9d/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "d57020dd-332c-425c-bf08-19e2d6f45d85",
			"parent_table": "block",
			"file_ids": [
				"21191c22-d2fa-400b-afaa-e7fcf9843d9d"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/6e75e9a2-b870-455b-b16d-90d102a667a8.png"
		},
		{
			"id": "af0daa2c-e449-455c-9a1a-82d5e69fa01e",
			"type": "callout",
			"properties": {
				"title": [
					[
						"С помощью ссылки iCal можно: 1, 2, 3\n\nСкопируйте имена участников"
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "0bcf70ac-23e8-4aa4-8856-c9240f8c232e",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d57020dd-332c-425c-bf08-19e2d6f45d85",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "8718b0d8-318e-4bfb-aa2f-c33e4d66b278",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/6e77b68f-7da8-4f0e-8b70-82f578c98a00/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/6e77b68f-7da8-4f0e-8b70-82f578c98a00/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "caa5eca3-7718-443e-b4b8-7b50706fb5b5",
			"parent_table": "block",
			"file_ids": [
				"6e77b68f-7da8-4f0e-8b70-82f578c98a00"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/8718b0d8-318e-4bfb-aa2f-c33e4d66b278.png"
		},
		{
			"id": "23eab659-30fd-443a-a9dd-1fe487a52dd5",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Ссылка iCal \n\nКопипаст участников встречи "
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "ce183d09-c0bc-40c1-8db8-903851782feb",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "caa5eca3-7718-443e-b4b8-7b50706fb5b5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "62a34664-5d28-47f8-81de-ffbb27f954e3",
			"type": "column",
			"content": [
				"44a3fe45-eb6f-4b71-b88c-18d38df610b7",
				"167f3806-8f65-45ad-b45a-3cb76646a7dc"
			],
			"format": {
				"column_ratio": 0.49999999999999994,
				"copied_from_pointer": {
					"id": "d1c2820a-d216-4ce8-8cca-b98b492693bf",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "bc39034e-2c64-44bc-a3db-f38ab00c27fd",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "015b9642-bbff-49f3-a799-e54b7a5b92cc",
			"type": "column",
			"content": [
				"155c66cc-d7d6-4814-a717-5854f254be39",
				"b7a3ea1c-2c0d-4682-84cb-0cc132795071"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "be8ee167-1f5f-4119-ad98-baf3a3ea17ed",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "bc39034e-2c64-44bc-a3db-f38ab00c27fd",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "44a3fe45-eb6f-4b71-b88c-18d38df610b7",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/2c822f55-511a-44f1-b6f7-4fe41bb298e6/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/2c822f55-511a-44f1-b6f7-4fe41bb298e6/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "62a34664-5d28-47f8-81de-ffbb27f954e3",
			"parent_table": "block",
			"file_ids": [
				"2c822f55-511a-44f1-b6f7-4fe41bb298e6"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/44a3fe45-eb6f-4b71-b88c-18d38df610b7.png"
		},
		{
			"id": "167f3806-8f65-45ad-b45a-3cb76646a7dc",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Здесь — лаконичный и точный текст "
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "5b3aef26-4088-4bb0-9e7e-d50b40b09aba",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "62a34664-5d28-47f8-81de-ffbb27f954e3",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "155c66cc-d7d6-4814-a717-5854f254be39",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/0d33e2c8-80e5-4465-b92f-c372e49854d9/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/0d33e2c8-80e5-4465-b92f-c372e49854d9/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "015b9642-bbff-49f3-a799-e54b7a5b92cc",
			"parent_table": "block",
			"file_ids": [
				"0d33e2c8-80e5-4465-b92f-c372e49854d9"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/155c66cc-d7d6-4814-a717-5854f254be39.png"
		},
		{
			"id": "b7a3ea1c-2c0d-4682-84cb-0cc132795071",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Тут какой-то длинный и скучный текст"
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "ff2a343b-e89f-4ce6-a81c-469f9da5b1f8",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "015b9642-bbff-49f3-a799-e54b7a5b92cc",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		}
	],
	"headers": [
		{
			"title": "Канцеляризмы ",
			"id": "916ffdab-ca2f-4964-b0ba-968ab34de1d9"
		},
		{
			"title": "Клише ",
			"id": "f52a03f6-3fc8-453f-b867-55103b76c639"
		},
		{
			"title": "Терминология ",
			"id": "72745913-9f75-4f67-a382-e64f7cbd0efd"
		},
		{
			"title": "Цепочка родительных",
			"id": "c2ab34e8-76b4-4eeb-a457-03090a9cc536"
		},
		{
			"title": "Отглагольные и глаголы на -тся",
			"id": "361bcc88-23d5-466a-87cb-5cf935a9df44"
		},
		{
			"title": "Причастные и деепричастные обороты",
			"id": "48b790b0-832d-47d0-95b6-6927439de720"
		},
		{
			"title": "На «вы» и с маленькой буквы",
			"id": "9b4229c0-0d72-460d-87d0-e1c6cd975286"
		},
		{
			"title": "Уважаемый! ",
			"id": "b59f1e21-862e-47c0-90db-c7def32d7112"
		},
		{
			"title": "Аббревиатуры, сокращения, англицизмы ",
			"id": "218e76a5-3577-4267-be42-aad8b069b42b"
		},
		{
			"title": "Длинные тексты ",
			"id": "290b78a6-8309-41fe-9ab9-f1d3c6e16662"
		}
	]
}} />
);

export default NotionVoiceAndToneEasy;
